import { maxBy } from 'lodash';
import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseProductivityRiskTrendProvider } from 'components/widgets/ProductivityRiskTrend/ProductivityRiskTrend.provider';
import { maxValueScale } from 'components/widgets/ProjectSummary/components/CardsSection/CardsSection.utils';

interface Props {
    api: UseProductivityRiskTrendProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useProductivityRiskTrendLogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getProductivityRiskTrend.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    const maxValuePoint = maxBy(api.getProductivityRiskTrend.instance.data?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;

    return {
        logic: {
            maxValue,
        },
    };
};
